// src/posthog.js
import posthog from "posthog-js";

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  capture_dead_clicks: false,
  person_profiles: "identified_only",
  loaded: (posthog) => {
    posthog.identify(posthog.get_distinct_id());
  },
});

export default posthog;
